import { match as Match } from "react-router-dom";
import { Card, CardBody, CardHeader } from '../../../_metronic/_partials/controls';
import { ProductCatalogWidget } from '../components/ProductCatalogWidget';

type Props = {
  cardProps?: any;
  match: Match<IRouteParams>;
}

interface IRouteParams {
  productCategory: string;
}

const ProductCatalogByGroupPage = ({ cardProps, match }: Props) => {
  return (
    <Card {...cardProps}>
      <CardHeader
        className='border-0'
        title={`Product Catalog - ${match.params.productCategory}`}
        {...cardProps}
      />
      <CardBody {...cardProps}>
        <ProductCatalogWidget productCategory={match.params.productCategory} />
      </CardBody>
    </Card>
  );
};

export { ProductCatalogByGroupPage };
